import { useState, useEffect, ChangeEvent } from "react";
import { SinglePhotoPickerProps } from "./types";

export function useSinglePhotoPickerController({
  value = "",
  onChange,
}: SinglePhotoPickerProps) {
  const [image, setImage] = useState<string>();

  useEffect(() => {
    if (value instanceof File || value instanceof Blob) {
      const reader = new FileReader();
      reader.onload = () => setImage(reader.result as string);
      reader.readAsDataURL(value);
    } else {
      setImage(value || "");
    }
  }, [value]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const reader = new FileReader();

      reader.onloadend = () => {
        setImage(reader.result as string);
      };

      reader.readAsDataURL(file);
      onChange?.(file);
    }
  };

  const handleRemove = () => {
    setImage("");
    onChange?.(null);
  };

  return {
    image,
    handleChange,
    handleRemove,
  };
}
